module.exports = __webpack_public_path__ + "img/Weaving_1200x800.83abbabc.png";